import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import moment from 'moment';
import { Card } from 'semantic-ui-react';
import SkeletonCard from 'components/common/Skeletons/Card';
import WalletDetailsModal from '../WalletDetailsModal';
import useWalletCard from '../useWalletCard';

import './index.scss';

const TotalCard = ({
  label,
  balance,
  data,
  loading,
  organizationName,
}) => {
  const { isModalVisible, openModal, closeModal } = useWalletCard();

  if (loading) {
    return (
      <Card className="total-card">
        <SkeletonCard variant="total" />
      </Card>
    );
  }

  return (
    <>
      <Card className="total-card">
        <div className="total-card__header">
          <span className="total-card__label">{label}</span>
          <div
            tabIndex="-1"
            role="button"
            onKeyDown={() => null}
            className="total-card__view-more"
            onClick={openModal}
          >
            View more
          </div>
        </div>

        <div className="total-card__balance">
          {numeral(balance).format('0.0a')}
        </div>

        <div className="total-card__footer">
          <span className="total-card__date">
            {moment().format('Do MMMM YYYY')}
          </span>
          {/* // TODO: this needs massive backend changes */}
          {/* <div className="wallet-card__right__last-period">
            <div className="wallet-card__right__last-period__icon" />
            <span>5% vs last period</span>
          </div> */}
        </div>
      </Card>

      <WalletDetailsModal
        isOpen={isModalVisible}
        onClose={closeModal}
        label={label}
        data={data}
        balance={balance}
        organizationName={organizationName}
      />
    </>
  );
};

TotalCard.propTypes = {
  label: PropTypes.string.isRequired,
  balance: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  organizationName: PropTypes.string.isRequired,
};

export default TotalCard;
